import { action, computed, atom, ReadableAtom } from 'nanostores';
import { SlideEntry } from '../types';

export default function createFormStepStore(stepEntries: SlideEntry[]) {
  const initialStep = stepEntries[0];
  const stepHistory = atom([initialStep]);
  const currentStep = computed(stepHistory, stepHistory => stepHistory[stepHistory.length - 1]);
  const isResultStep = computed(currentStep, currentStep => currentStep.tracking === 'suc_phone_lead');
  const isAlreadyBookedStep = computed(currentStep, currentStep => currentStep.id === 'consultation-already-booked');

  const nextStep = action(stepHistory, 'nextStep', (currentStepHistory, id?: string) => {
    const $currentStepHistory = currentStepHistory.get();
    const $currentStep = $currentStepHistory.slice(-1)[0];

    if ($currentStep.id === id) {
      return;
    }

    const newEntry = id ? stepEntries.find(entry => entry.id === id) : stepEntries.find(entry => $currentStep.order < entry.order);

    if (!newEntry) {
      console.warn('there is no step with the id', id);
      return;
    }

    currentStepHistory.set([...$currentStepHistory, newEntry]);
  });

  const gotoStep = action(stepHistory, 'gotoStep', (currentStepHistory, id: string) => {
    const $currentStepHistory = currentStepHistory.get();
    const targetStepIndex = $currentStepHistory.slice(0, -1).findIndex(step => step.id === id);

    if (targetStepIndex === -1) {
      return;
    }

    currentStepHistory.set($currentStepHistory.slice(0, targetStepIndex + 1));
  });

  const previousStep = action(stepHistory, 'previousStep', currentStepHistory => {
    currentStepHistory.set(currentStepHistory.get().slice(0, -1));
  });

  const reset = action(stepHistory, 'reset', () => [initialStep]);

  return {
    currentStep,
    isResultStep,
    isAlreadyBookedStep,
    history: stepHistory as ReadableAtom<SlideEntry[]>,
    nextStep,
    previousStep,
    gotoStep,
    reset
  };
}

export type FormStepStore = ReturnType<typeof createFormStepStore>;
